import React from "react";
import { AxiosError } from "axios";
import { MakeRequest } from "../DataUtil";
import SmallSpinner from "../SmallSpinner";
import { Validator } from "../Validation/Validator";
import {
  getAllFormElements,
  showValidationErrors,
  resetValidationErrors,
} from "../Utilities";
import ValidationSummary from "../Validation/ValidationSummary";
import { getCustomStyles } from "../../components/Utilities";
import Select from "react-select";

let sizeOptions: any[];

interface Props {
  onToaster: any;
}

interface State {
  sizeValue: string;
  sizeId: number;
  price: number;
  formErrors: any;
  renderCount: number;
  redirect: boolean;
  sizes: any;
  selectedSize: any;
  isLoading: boolean;
  prints: any;
}

class AddPrintForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      sizeValue: "",
      sizeId: 0,
      price: 0,
      formErrors: [],
      renderCount: 0,
      redirect: false,
      sizes: [],
      selectedSize: null,
      isLoading: false,
      prints: [],
    };
    this.handleAddPrint = this.handleAddPrint.bind(this);
    this.handlePriceChange = this.handlePriceChange.bind(this);
    this.handleSizeChange = this.handleSizeChange.bind(this);
  }
  loadSizes = async (): Promise<any> => {
    const successCallback = (result: any): void => {
      if (result && result.Success) {
        this.setState(
          {
            sizes: result.Data,
          },
          () => {
            sizeOptions = this.state.sizes.map((item: any) => {
              return { label: item.SizeValue, value: item.SizeId };
            });
            this.setState({ renderCount: this.state.renderCount + 1 });
          }
        );
      }
    };
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        console.log(error.response ? error.message : "Unknown Error");
      }
    };
    MakeRequest({
      url: "Painting/GetAllSizes",
      method: "get",
      data: {},
      successCallback,
      errorCallback,
    });
  };
  loadPrints = async (): Promise<any> => {
    const successCallback = (result: any): void => {
      if (result && result.Success) {
        this.setState({
          prints: result.Data,
        });
      }
    };
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        console.log(error.response ? error.message : "Unknown Error");
      }
    };
    MakeRequest({
      url: "Painting/GetPrints",
      method: "get",
      data: {},
      successCallback,
      errorCallback,
    });
  };
  postData(data: any): void {
    //process results from ajax call
    const successCallback = (result: any): void => {
      if (result && result !== undefined) {
        //do logic
        if (result.Success === true) {
          this.props.onToaster({ success: true }, "Success: Print Added");
          this.setState({
            sizeId: 0,
            price: 0,
            isLoading: false,
            selectedSize: null,
          });
        } else {
          this.props.onToaster({ error: true }, "Error: " + result.Message);
          this.setState({ isLoading: false });
        }
      }
    };
    //handle errors
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        this.setState({ isLoading: false });
        this.setState({ isLoading: false }, () => {
          this.props.onToaster(
            { error: true },
            error.response ? error.message : "Unknown Error"
          );
        });
        if (
          error.response &&
          error.response.status &&
          error.response.status === 401
        ) {
        }
      }
    };
    MakeRequest({
      url: "Admin/AddPrint",
      method: "post",
      data: { postData: data },
      successCallback,
      errorCallback,
    });
  }
  handleBlurValidation = (e: any) => {
    let errors = Validator({ fields: e.target });
    if (errors.length === 0) {
      this.setState({ formErrors: [] }, () => {
        resetValidationErrors(e.target);
      });
    } else {
      this.setState({ formErrors: errors }, () => {
        showValidationErrors(this.state.formErrors);
      });
    }
  };

  handleFocus = (e: any) => {
    this.setState({ formErrors: [] }, () => {
      resetValidationErrors(e.target);
    });
  };
  handlePriceChange = (e: any) => {
    if (e !== null && e !== undefined) {
      this.setState({ price: parseFloat(e.target.value) });
    }
  };
  handleSizeChange = (e: any) => {
    this.setState({ sizeValue: e.label, sizeId: e.value, selectedSize: e });
  };
  handleAddPrint = (e: any) => {
    if (e !== null && e !== undefined) {
      e.preventDefault();
      this.setState({ isLoading: true });
      const size: string = this.state.sizeValue.trim();
      const sizeId: number = this.state.sizeId;
      const price: number = this.state.price;
      let form = document.getElementById("addPrintForm");
      let allFormElements = getAllFormElements({ element: form ? form : e });
      let errors = Validator({ fields: allFormElements });

      //do size format check
      ///\d{2} [xX] \d{2}/gm is 00 X 00
      let pattern = size.search(/\d{2} [xX] \d{2}/gm);
      if (pattern === -1) {
        let error = {
          fieldName: "size",
          message: "Size should follow this format e.g 40 X 40",
        };
        errors?.push(error);
      }

      //check to see if we already have the same print value
      let printFound: any = this.state.prints.find(
        (item: any) => item.SizeId === sizeId
      );

      if (printFound) {
        let error = {
          fieldName: "size",
          message: "This print value already exists",
        };
        errors?.push(error);
      }

      if (errors.length === 0) {
        //update state
        let print: any = {
          Size: size,
          SizeId: sizeId,
          Price: price,
        };
        this.setState({ formErrors: [] }, () => {
          resetValidationErrors(e.target);
          //save the data
          this.postData(print);
        });
      } else {
        this.setState({ isLoading: false, formErrors: errors }, () => {
          showValidationErrors(this.state.formErrors);
        });
      }
    }
  };
  componentDidMount(): void {
    this.loadSizes();
    this.loadPrints();
  }
  render() {
    return (
      <div className="col-md-5 col-sm-6">
        <div className="card-form">
          <h5 className="card-title">Add Print</h5>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <SmallSpinner
                  isLoading={this.state.isLoading}
                  actionText="Please Wait"
                />
              </div>
            </div>
          </div>
          <ValidationSummary Errors={this.state.formErrors} />
          <form
            id="addPrintForm"
            onSubmit={this.handleAddPrint}
            encType="multipart/form-data"
          >
            <div className="form-group">
              <label htmlFor="price" className="label-dark">
                Price
              </label>
              <input
                id="price"
                className="form-control border-input"
                type="number"
                value={this.state.price || 0}
                onChange={this.handlePriceChange}
                onBlur={this.handleBlurValidation}
                onFocus={this.handleFocus}
                placeholder="Price"
                data-required="true"
                data-min="1"
                data-validationname="Price"
                data-id="price"
              />
            </div>
            <div className="form-group">
              <label htmlFor="sizes" className="label-dark">
                Size
              </label>
              <Select
                id="sizes"
                value={this.state.selectedSize}
                onChange={this.handleSizeChange}
                options={sizeOptions}
                styles={getCustomStyles()}
              />
            </div>
            <div className="card-footer">
              <button
                className="btn btn-success btn-round"
                data-id="AddBtn"
                type="submit"
              >
                Add Print
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
export default AddPrintForm;
